export const API_URL = import.meta.env.VITE_API_URL || process.env.REACT_APP_API_URL;
export const AUTH_URL = import.meta.env.VITE_AUTH_URL || process.env.REACT_APP_AUTH_URL;
export const AUTH_SCREEN = (import.meta.env.VITE_AUTH_URL || process.env.REACT_APP_AUTH_URL) + "?theme=light&redirect=" + window.location.origin;